import { ParcelsPage } from '@/pages/parcels'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/parcels')({
  component: ParcelsPage,
})
